import { Component } from '@angular/core';

@Component({
    selector: 'app-partner',
    templateUrl: './partner.component.html',
    styleUrls: ['./partner.component.css']
})
export class PartnerComponent {

    slides = [
        {image: '/assets/landing/soludo-chuks.png', btnText: ''},
        {image: '/assets/landing/greg-ezeilo.png', btnText: ''},
        {image: '/assets/landing/greg-ezeilo2.png', btnText: ''},
        {image: '/assets/img/ofomata.jpg', btnText: ''},
        {image: '/assets/img/chika.png', btnText: ''},
        {image: '/assets/img/chuks.jpg', btnText: ''},
    ]

    pauseAnimation() {
        const scrollContent = document.querySelector('.scroll-content') as HTMLElement;
        scrollContent.style.animationPlayState = 'paused';
    }

    resumeAnimation() {
        const scrollContent = document.querySelector('.scroll-content') as HTMLElement;
        scrollContent.style.animationPlayState = 'running';
    }
}
